import { render, staticRenderFns } from "./InstructorArticle.vue?vue&type=template&id=f5b56c0c&"
import script from "./InstructorArticle.vue?vue&type=script&lang=ts&"
export * from "./InstructorArticle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports